import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResult } from "@app/shared/model/apiresult";
import { Guid } from "guid-typescript";
import { catchError, map } from 'rxjs/operators';
import { environment as env } from '@environments/environment'
import { throwError } from "rxjs";
import { IAuditTrail } from "../model/audit-trail-model";

@Injectable({ providedIn: 'root' })

export class AuditTrailService {
    constructor(private http: HttpClient) { }

    get(studentId: Guid) {
        return this.http.get<ApiResult<IAuditTrail[]>>(env.apiUrl + 'AuditTrail/' + studentId);
    }
    handleError(error: HttpErrorResponse) {
        return throwError(error);
    }
}